<template>
	<div class="bottom">
	</div>
	<img class="bottombg" src="../../assets/img/bottom.png" >
</template>

<script>
</script>

<style scoped="scoped">
	.bottom{
		position: absolute;
		width: 100vw;
		bottom: 0;
		height: 10vh;
		background: linear-gradient(to top ,rgba(15, 32, 53,1) , rgba(15, 32, 53,0));
		background-size: 100% auto;
		background-position:0% 80%;
		border: none;
	}
	.bottombg{
		display: block;
		width: 100%;
		position: absolute;
		bottom: 1.8%;
		z-index: 2;
	}
	
</style>
